import { useLayoutEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import type { PolicyLink } from '../services/types'
import { decodePolicyRef } from '../utils/decodePolicyRef'
import { CLAIM_FLOW_PATH } from '../claims/claimFlowModel'

/**
 * Legacy `/claims/windscreen/gst` route: GST is collected on the review step.
 * This screen immediately replaces the URL with the describe step for backwards compatibility.
 */
export default function ClaimWindscreenGstStep() {
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const policyRef = decodePolicyRef(queryParams.get('policyRef'))
  const typeInQuery = queryParams.get('type')
  const navState = location.state as { policy?: PolicyLink; preserveScroll?: boolean } | null

  useLayoutEffect(() => {
    const p = new URLSearchParams()
    if (policyRef) p.set('policyRef', policyRef)
    if (typeInQuery) p.set('type', typeInQuery)
    const q = p.toString()
    const path = q ? `${CLAIM_FLOW_PATH.windscreen}?${q}` : CLAIM_FLOW_PATH.windscreen
    navigate(path, {
      replace: true,
      state: navState?.policy ? { policy: navState.policy } : undefined,
    })
  }, [navigate, navState?.policy, policyRef, typeInQuery])

  return null
}
